import { render, staticRenderFns } from "./project-group-template-directory-tree.vue?vue&type=template&id=8196b53c&scoped=true&"
import script from "./project-group-template-directory-tree.vue?vue&type=script&lang=ts&"
export * from "./project-group-template-directory-tree.vue?vue&type=script&lang=ts&"
import style0 from "./project-group-template-directory-tree.vue?vue&type=style&index=0&id=8196b53c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8196b53c",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VBtn,VCheckbox,VDivider,VIcon,VList,VListItem,VListItemAvatar,VListItemTitle,VMenu,VProgressLinear,VTextField,VToolbar,VTreeview})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Sources\\nothegger.topwm\\Nothegger.TopWM.Warehouse.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8196b53c')) {
      api.createRecord('8196b53c', component.options)
    } else {
      api.reload('8196b53c', component.options)
    }
    module.hot.accept("./project-group-template-directory-tree.vue?vue&type=template&id=8196b53c&scoped=true&", function () {
      api.rerender('8196b53c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/projects/components/project-group-template-directory-tree.vue"
export default component.exports